import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

// tslint:disable-next-line:ban-types
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {
  private isDestroyed = new Subject();

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private localStorageService: LocalStorageService,
  ) {
    this.applyAnalytics();
    this.consentSnackBar();
  }

  private applyAnalytics(): void {
    this.router.events
      .pipe(
        takeUntil(this.isDestroyed)
      )
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'G-RX1FT5FG3L', {
            'page-path': event.urlAfterRedirects
          });
        }
      });
  }

  private consentSnackBar(): void {
    if (!this.localStorageService.getConsentToCookies()) {
      const snackBaRef = this.snackBar.open(`This website uses cookies to ensure you get the best experience on our website`, 'Got it 👍', {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
      });

      snackBaRef.afterDismissed()
        .pipe(
          takeUntil(this.isDestroyed)
        ).subscribe((res) => {
        if (res.dismissedByAction) {
          this.localStorageService.consentToCookies();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.isDestroyed.next();
    this.isDestroyed.complete();
  }


}
